export const Data = [
    {
        question:'HISTORY',
        answer:`I first started coding sometime in 2020 after taking a Python course during my National service year. The very first thing I built was a command-line GPA calculator and from then, I was hooked.

        I knew I enjoyed figuring out the logic behind creating applications but I was more interested in learning how to make it look pretty to users. That's how I started my career in front end development, and

        In order to transition into tech properly i decided to go for a 6 month programme in web app development at Aptech computer Institute lagos where i learnt the Programming languages i needed to become a frontend developer. I completed the Programe with 
        
        a grade score of 77% (distinction) and after that i decided to go into self learning and development so as to improve my frontend skills..
        
        I’m constantly trying to learn new technologies and concepts and I try to share my knowledge by writing articles and posting helpful contents on LinkedIN.
        
        I enjoy building fun designs and time-saving projects on Github.
        
        
        Currently, I’m focused on moving to the next stage of my career and achieving that senior-level developer status.
        Thanks for reading 😊
        
        `,
    }
]